// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"3e9e12cd","160":"126010eb","208":"3427cd37","293":"1e4fda9a","453":"251bc4bb","516":"01ab62ea","519":"a1d63526","917":"629f2b38","946":"c672ca1e"}[chunkId] + ".chunk.js";
};